<div class="example-container main-page-content" [class.example-is-mobile]="mobileQuery.matches" >
  <mat-toolbar  class="example-toolbar">
    <button mat-icon-button (click)="snav.toggle()"><mat-icon>menu</mat-icon></button>
    <div class="logo-container" >
      <img src="./assets/logos/sethala-logo.png" height="45" (click)="snav.toggle()" style="padding-bottom: 5px; padding-top:5px">
    </div>
    <span class="example-spacer"></span>
    <div  fxLayout="column" fxFlex="10" fxShow.lt-sm="false" fxLayoutAlign="end center" class="" fxLayoutGap="10px">
      <div fxLayout="row" fxLayoutAlign="end center" class="" fxFill fxLayoutGap="10px" style="cursor: pointer;">
        <!-- <div fxLayout="column" class="fh " fxLayoutAlign="center center">
          <button mat-button color="secondary" (click)="ViewNotifications()" >
            <mat-icon [ngStyle]="{'color':'white'}" > notifications </mat-icon> Alerts
          </button>
        </div> -->
        <div fxLayout="column" class="fh" fxLayoutAlign="center center" >
            <div class="form-group" style="min-width: 250px">
                <mat-select
                class="form-control"
                matInput
                [(ngModel)]="selectedSiteId"
                (valueChange)="selectedSiteChanged($event)"
              >
                <input
                  (keydown)="$event.stopPropagation()"
                  (keyup)="onSitesKeyUp($event)"
                  class="form-control example-full-width w-100"
                  placeholder="Search"
                />
                <!-- <mat-option [value]="''"> Select All </mat-option> -->
                <mat-option
                  *ngFor="let element of selectedSites"
                  [value]="element.SiteId"
                >
                  {{ element.SiteName }}
                </mat-option>
              </mat-select>
            </div>
        </div>
        <div fxLayout="column" class="fh" fxLayoutAlign="center center" >
          <button mat-button color="secondary" (click)="ViewProfile()" >
            <mat-icon [ngStyle]="{'color':'white'}" > person </mat-icon> Profile
          </button>
        </div>
        <div fxLayout="column" class="fh" fxLayoutAlign="center center" >
          <button mat-button color="danger" class="text-danger" (click)="Logout()"  >
            <mat-icon [ngStyle]="{'color':'red'}"> logout </mat-icon> Logout
          </button>
        </div>
      </div>
    </div>
  </mat-toolbar>

  <mat-sidenav-container class="example-sidenav-container" >
    <mat-sidenav #snav [mode]="mobileQuery.matches ? 'over' : 'side'"  opened="false">
      <ejs-accordion expandMode='Multiple' class="full-width " >
        <e-accordionitems>
          <e-accordionitem expanded='true'>
            <ng-template #header>
              <div fxLayout="row" fxLayoutAlign="start center" class="" fxFill fxLayoutGap="5px">
                <div fxLayout="column" class="" fxLayoutAlign="center center">

                </div>
                <div fxLayout="column" class="" fxLayoutAlign="center center">
                  <div matListItemTitle>Home</div>
                </div>
              </div>
            </ng-template>

            <ng-template #content>
              <div fxLayout="column" class="" fxLayoutAlign="center center" fxLayoutGap="5px">
              <div fxLayout="row" fxLayoutAlign="start center" class="" fxFill fxLayoutGap="5px" (click)="NavigateToOverview()"  style="cursor: pointer;">
                <div fxLayout="column" class="" fxLayoutAlign="center center">
                  <mat-icon matListItemIcon>assessment</mat-icon>
                </div>
                <div fxLayout="column" class="" fxLayoutAlign="center center">
                  <div matListItemTitle>Overview</div>
                </div>
              </div>
              <div fxLayout="row" fxLayoutAlign="start center" class="" fxFill fxLayoutGap="5px"  (click)="NavigateToRealtime()"  style="cursor: pointer;">
                <div fxLayout="column" class="" fxLayoutAlign="center center">
                  <mat-icon matListItemIcon>wifi_tethering</mat-icon>
                </div>
                <div fxLayout="column" class="" fxLayoutAlign="center center">
                  <div matListItemTitle>Map </div>
                </div>
              </div>
              <div fxLayout="row" fxLayoutAlign="start center" class="" fxFill fxLayoutGap="5px"  (click)="NavigateToRealtime2()"  style="cursor: pointer;">
                <div fxLayout="column" class="" fxLayoutAlign="center center">
                  <mat-icon matListItemIcon>my_location</mat-icon>
                </div>
                <div fxLayout="column" class="" fxLayoutAlign="center center">
                  <div matListItemTitle>Locate</div>
                </div>
              </div>

              <div fxLayout="row" fxLayoutAlign="start center" class="" fxFill fxLayoutGap="5px" (click)="NavigateToActivity()"  style="cursor: pointer;">
                <div fxLayout="column" class="" fxLayoutAlign="center center">
                  <mat-icon matListItemIcon>double_arrow</mat-icon>
                </div>
                <div fxLayout="column" class="" fxLayoutAlign="center center">
                  <div matListItemTitle>Activity</div>
                </div>
              </div>
              <div fxLayout="row" fxLayoutAlign="start center" class="" fxFill fxLayoutGap="5px" (click)="NavigateToDashboard()"  style="cursor: pointer;">
                <div fxLayout="column" class="" fxLayoutAlign="center center">
                  <mat-icon matListItemIcon>dashboard</mat-icon>
                </div>
                <div fxLayout="column" class="" fxLayoutAlign="center center">
                  <div matListItemTitle>Dashboards</div>
                </div>
              </div>
              <div fxLayout="row" fxLayoutAlign="start center" class="" fxFill fxLayoutGap="5px" (click)="NavigateToSecurityAlerts()"  style="cursor: pointer;">
                <div fxLayout="column" class="" fxLayoutAlign="center center">
                  <mat-icon matListItemIcon>notifications_active</mat-icon>
                </div>
                <div fxLayout="column" class="" fxLayoutAlign="center center">
                  <div matListItemTitle>Alerts</div>
                </div>
              </div>
              <div fxLayout="row" fxLayoutAlign="start center" class="" fxFill fxLayoutGap="5px" (click)="NavigateToAssetStatusTemplate()"  style="cursor: pointer;">
                <div fxLayout="column" class="" fxLayoutAlign="center center">
                  <mat-icon matListItemIcon>local_activity</mat-icon>
                </div>
                <div fxLayout="column" class="" fxLayoutAlign="center center">
                  <div matListItemTitle>Asset Activity Status</div>
                </div>
              </div>
              <div *ngIf="!isAdminUser" fxLayout="row" fxLayoutAlign="start center" class="" fxFill fxLayoutGap="5px" (click)="NavigateToThing()" style="cursor: pointer;">
                <div fxLayout="column" class="" fxLayoutAlign="center center">
                  <mat-icon matListItemIcon>security</mat-icon>
                </div>
                <div fxLayout="column" class="" fxLayoutAlign="center center">
                  <div matListItemTitle>Assets</div>
                </div>
              </div>
              </div>

            </ng-template>
          </e-accordionitem>

          <mat-divider></mat-divider>
          <!--Administrator-->
          <e-accordionitem expanded='true' *ngIf="isAdminUser || isSuperAdminUser">
            <ng-template #header>
              <div fxLayout="row" fxLayoutAlign="start center" class="" fxFill fxLayoutGap="5px">
                <div fxLayout="column" class="" fxLayoutAlign="center center">

                </div>
                <div fxLayout="column" class="" fxLayoutAlign="center center">
                  <div matListItemTitle>Administration</div>
                </div>
              </div>
            </ng-template>
            <ng-template #content>
              <div fxLayout="column" class="" fxLayoutAlign="center center" fxLayoutGap="5px">
                <div fxLayout="row" fxLayoutAlign="start center" class="" fxFill fxLayoutGap="5px"(click)="NavigateToSite()"  style="cursor: pointer;" *ngIf="isSuperAdminUser">
                  <div fxLayout="column" class="" fxLayoutAlign="center center">
                    <mat-icon matListItemIcon>my_location</mat-icon>
                  </div>
                  <div fxLayout="column" class="" fxLayoutAlign="center center">
                    <div matListItemTitle>Sites</div>
                  </div>
                </div>
              <div fxLayout="row" fxLayoutAlign="start center" class="" fxFill fxLayoutGap="5px" (click)="NavigateToBuilding()"  style="cursor: pointer;">
                <div fxLayout="column" class="" fxLayoutAlign="center center">
                  <mat-icon matListItemIcon>business</mat-icon>
                </div>
                <div fxLayout="column" class="" fxLayoutAlign="center center">
                  <div matListItemTitle>Buildings</div>
                </div>
              </div>
              <div fxLayout="row" fxLayoutAlign="start center" class="" fxFill fxLayoutGap="5px"(click)="NavigateToFloor()"  style="cursor: pointer;">
                <div fxLayout="column" class="" fxLayoutAlign="center center">
                  <mat-icon matListItemIcon>map</mat-icon>
                </div>
                <div fxLayout="column" class="" fxLayoutAlign="center center">
                  <div matListItemTitle>Floors</div>
                </div>
              </div>
              <div fxLayout="row" fxLayoutAlign="start center" class="" fxFill fxLayoutGap="5px"(click)="NavigateToZone()"  style="cursor: pointer;">
                <div fxLayout="column" class="" fxLayoutAlign="center center">
                  <mat-icon matListItemIcon>filter_center_focus</mat-icon>
                </div>
                <div fxLayout="column" class="" fxLayoutAlign="center center">
                  <div matListItemTitle>Zones</div>
                </div>
              </div>
              <div fxLayout="row" fxLayoutAlign="start center" class="" fxFill fxLayoutGap="5px"(click)="NavigateToDepartment()"  style="cursor: pointer;">
                <div fxLayout="column" class="" fxLayoutAlign="center center">
                  <mat-icon matListItemIcon>account_tree</mat-icon>
                </div>
                <div fxLayout="column" class="" fxLayoutAlign="center center">
                  <div matListItemTitle>Departments</div>
                </div>
              </div>
              <div fxLayout="row" fxLayoutAlign="start center" class="" fxFill fxLayoutGap="5px"(click)="NavigateToLocation()"  style="cursor: pointer;">
                <div fxLayout="column" class="" fxLayoutAlign="center center">
                  <mat-icon matListItemIcon>place</mat-icon>
                </div>
                <div fxLayout="column" class="" fxLayoutAlign="center center">
                  <div matListItemTitle>Locations</div>
                </div>
              </div>
              <div fxLayout="row" fxLayoutAlign="start center" class="" fxFill fxLayoutGap="5px"(click)="NavigateToDevice()"  style="cursor: pointer;">
                <div fxLayout="column" class="" fxLayoutAlign="center center">
                  <mat-icon matListItemIcon>router</mat-icon>
                </div>
                <div fxLayout="column" class="" fxLayoutAlign="center center">
                  <div matListItemTitle>Nodes</div>
                </div>
              </div>
              <div fxLayout="row" fxLayoutAlign="start center" class="" fxFill fxLayoutGap="5px"(click)="NavigateToEntities()"  style="cursor: pointer;">
                <div fxLayout="column" class="" fxLayoutAlign="center center">
                  <mat-icon matListItemIcon>drive_folder_upload</mat-icon>
                </div>
                <div fxLayout="column" class="" fxLayoutAlign="center center">
                  <div matListItemTitle>Entity</div>
                </div>
              </div>
              <div fxLayout="row" fxLayoutAlign="start center" class="" fxFill fxLayoutGap="5px"(click)="NavigateToAsset()"  style="cursor: pointer;">
                <div fxLayout="column" class="" fxLayoutAlign="center center">
                  <mat-icon matListItemIcon>local_offer</mat-icon>
                </div>
                <div fxLayout="column" class="" fxLayoutAlign="center center">
                  <div matListItemTitle>Tags</div>
                </div>
              </div>

              <div fxLayout="row" fxLayoutAlign="start center" class="" fxFill fxLayoutGap="5px"(click)="NavigateToThing()"  style="cursor: pointer;">
                <div fxLayout="column" class="" fxLayoutAlign="center center">
                  <mat-icon matListItemIcon>security</mat-icon>
                </div>
                <div fxLayout="column" class="" fxLayoutAlign="center center">
                  <div matListItemTitle>Assets</div>
                </div>
              </div>

              <div fxLayout="row" fxLayoutAlign="start center" class="" fxFill fxLayoutGap="5px"(click)="NavigateToUser()"  style="cursor: pointer;">
                <div fxLayout="column" class="" fxLayoutAlign="center center">
                  <mat-icon matListItemIcon>group</mat-icon>
                </div>
                <div fxLayout="column" class="" fxLayoutAlign="center center">
                  <div matListItemTitle>Users</div>
                </div>
              </div>

              <div fxLayout="row" fxLayoutAlign="start center" class="" fxFill fxLayoutGap="5px"(click)="NavigateToDynamicAlertTemplate()"  style="cursor: pointer;">
                <div fxLayout="column" class="" fxLayoutAlign="center center">
                  <mat-icon matListItemIcon>library_add</mat-icon>
                </div>
                <div fxLayout="column" class="" fxLayoutAlign="center center">
                  <div matListItemTitle>Alert Template</div>
                </div>
              </div>

            </div>
            </ng-template>
          </e-accordionitem>
<!--
          <mat-divider></mat-divider>

          <e-accordionitem *ngIf="isAdminUser">
            <ng-template #header>
              <div fxLayout="row" fxLayoutAlign="start center" class="" fxFill fxLayoutGap="5px">
                <div fxLayout="column" class="" fxLayoutAlign="center center">

                </div>
                <div fxLayout="column" class="" fxLayoutAlign="center center">
                  <div matListItemTitle>Reports</div>
                </div>
              </div>
            </ng-template>

            <ng-template #content>
              <div fxLayout="column" class="" fxLayoutAlign="center center" fxLayoutGap="5px">
              <div fxLayout="row" fxLayoutAlign="start center" class="" fxFill fxLayoutGap="5px">
                <div fxLayout="column" class="" fxLayoutAlign="center center">
                  <mat-icon matListItemIcon>assessment</mat-icon>
                </div>
                <div fxLayout="column" class="" fxLayoutAlign="center center">
                  <div matListItemTitle>Platform</div>
                </div>
              </div>
              <div fxLayout="row" fxLayoutAlign="start center" class="" fxFill fxLayoutGap="5px">
                <div fxLayout="column" class="" fxLayoutAlign="center center">
                  <mat-icon matListItemIcon>assessment</mat-icon>
                </div>
                <div fxLayout="column" class="" fxLayoutAlign="center center">
                  <div matListItemTitle>User Activity</div>
                </div>
              </div>
              <div fxLayout="row" fxLayoutAlign="start center" class="" fxFill fxLayoutGap="5px">
                <div fxLayout="column" class="" fxLayoutAlign="center center">
                  <mat-icon matListItemIcon>assessment</mat-icon>
                </div>
                <div fxLayout="column" class="" fxLayoutAlign="center center">
                  <div matListItemTitle>Movement</div>
                </div>
              </div>
              <div fxLayout="row" fxLayoutAlign="start center" class="" fxFill fxLayoutGap="5px">
                <div fxLayout="column" class="" fxLayoutAlign="center center">
                  <mat-icon matListItemIcon>assessment</mat-icon>
                </div>
                <div fxLayout="column" class="" fxLayoutAlign="center center">
                  <div matListItemTitle>Location</div>
                </div>
              </div>
              <div fxLayout="row" fxLayoutAlign="start center" class="" fxFill fxLayoutGap="5px">
                <div fxLayout="column" class="" fxLayoutAlign="center center">
                  <mat-icon matListItemIcon>assessment</mat-icon>
                </div>
                <div fxLayout="column" class="" fxLayoutAlign="center center">
                  <div matListItemTitle>Reallocation</div>
                </div>
              </div>
              <div fxLayout="row" fxLayoutAlign="start center" class="" fxFill fxLayoutGap="5px">
                <div fxLayout="column" class="" fxLayoutAlign="center center">
                  <mat-icon matListItemIcon>assessment</mat-icon>
                </div>
                <div fxLayout="column" class="" fxLayoutAlign="center center">
                  <div matListItemTitle>Enter Exit</div>
                </div>
              </div>
            </div>

            </ng-template>
          </e-accordionitem> -->

          <mat-divider></mat-divider>

          <e-accordionitem expanded='false'>
            <ng-template #header>
              <div fxLayout="row" fxLayoutAlign="start center" class="" fxFill fxLayoutGap="5px">
                <div fxLayout="column" class="" fxLayoutAlign="center center">

                </div>
                <div fxLayout="column" class="" fxLayoutAlign="center center">
                  <div matListItemTitle>Platform</div>
                </div>
              </div>

            </ng-template>
            <ng-template #content>

              <div fxLayout="column" class="" fxLayoutAlign="center center" fxLayoutGap="5px">
                <div fxLayout="row" fxLayoutAlign="start center" class="" fxFill fxLayoutGap="5px">
                  <div fxLayout="column" class="" fxLayoutAlign="center center">
                    <mat-icon matListItemIcon>security</mat-icon>
                  </div>
                  <div fxLayout="column" class="" fxLayoutAlign="center center">
                    <a class="link" href="https://wiki.sethala.com/en/platform/security" target="_blank" matListItemTitle>Security</a>
                  </div>
                </div>
                <div fxLayout="row" fxLayoutAlign="start center" class="" fxFill fxLayoutGap="5px">
                <div fxLayout="column" class="" fxLayoutAlign="center center">
                  <mat-icon matListItemIcon>help_outline</mat-icon>
                </div>
                <div fxLayout="column" class="" fxLayoutAlign="center center">
                  <a class="link" href="https://wiki.sethala.com/" target="_blank" matListItemTitle>Wiki</a>
                </div>
              </div>
              <div fxLayout="row" fxLayoutAlign="start center" class="" fxFill fxLayoutGap="5px">
                <div fxLayout="column" class="" fxLayoutAlign="center center">
                  <mat-icon matListItemIcon>bug_report</mat-icon>
                </div>
                <div fxLayout="column" class="" fxLayoutAlign="center center">
                  <a class="link" href="https://sethala.atlassian.net/servicedesk/customer/portal/2" target="_blank" matListItemTitle>Report a Bug</a>
                </div>
              </div>

              <div fxLayout="row" fxLayoutAlign="start center" class="" fxFill fxLayoutGap="5px">
                <div fxLayout="column" class="" fxLayoutAlign="center center">
                  <mat-icon matListItemIcon>contact_support</mat-icon>
                </div>
                <div fxLayout="column" class="" fxLayoutAlign="center center">
                  <a class="link" href="https://sethala.atlassian.net/servicedesk/customer/portal/2" target="_blank" matListItemTitle>Support</a>
                </div>
              </div>

              <div fxLayout="row" fxLayoutAlign="start center" class="" fxFill fxLayoutGap="5px">
                <div fxLayout="column" class="" fxLayoutAlign="center center">
                  <mat-icon matListItemIcon>developer_board</mat-icon>
                </div>
                <div fxLayout="column" class="" fxLayoutAlign="center center">
                  <a href="javascript:void(0)" class="link" matListItemTitle>Version 2.2.29</a>
                </div>
              </div>
            </div>
            </ng-template>
          </e-accordionitem>

        </e-accordionitems>
      </ejs-accordion>
    </mat-sidenav>

    <mat-sidenav-content>
      <div id="content" fxLayout="column" fxFlex="100" fxLayoutGap="1px">

        <div fxLayout="row" class="fw " fxShow="true" [hidden]="!BreadcrumbLocation">
          <div fxLayoutAlign="stretch" fxFlex="100">
            <div class="shell-container" fxFill FxFlex="100">
              <mat-card class="mat-elevation-z9 breadcrumb-padding">
                <mat-card-content class="no-padding">
                  <ejs-breadcrumb [enableNavigation]="false">
                    <e-breadcrumb-items>
                      <e-breadcrumb-item [text]="BreadcrumbLocation"></e-breadcrumb-item>
                    </e-breadcrumb-items>
                  </ejs-breadcrumb>
                </mat-card-content>
              </mat-card>
            </div>
          </div>
        </div>
      <!--

      -->
        <div fxLayout="row" class="fh" >
          <div fxLayoutAlign="stretch" fxFlex="100" >
            <div class="shell-container" fxFill fxFlex="100" >
              <mat-card class="mat-elevation-z0  secure-router-card" fxFlex="100">
                <mat-card-content  >
                  <div class="control-section">
                    <router-outlet name="secure" ></router-outlet>
                  </div>

                </mat-card-content>
              </mat-card>
            </div>
          </div>
        </div>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>

<!-- Snackbar Content Template -->
<ng-template #snackbarTemplate let-data>
  <div class="custom-snackbar">
    <mat-icon color="warn" class="snackbar-icon">warning</mat-icon>
    <span>{{ data.message }}</span>
  </div>
</ng-template>
<!-- Snackbar Content Template -->
<ejs-toast #element  [position] = 'position' > </ejs-toast>

<!-- Copyright 2019 Google Inc. All Rights Reserved.
    Use of this source code is governed by an MIT-style license that
    can be found in the LICENSE file at http://angular.io/license -->
